import questionnaireService from "./questionnaireService";

const qnrService = [
    ...questionnaireService
]

export default qnrService;
export {questionnaireService};

